import { useCallback } from 'react'
import { omit } from '@nwwp/utils'
import { useStandardTrack } from './use-standard-track'

type TrackElementInteractedParams = {
  element: string
  href?: string
  parentEventId?: string
} & Record<string, unknown>

export const useTrackElementInteracted = () => {
  const track = useStandardTrack()

  return useCallback(
    (params: TrackElementInteractedParams) => {
      if (!params.parentEventId) return

      const rest = omit(params, ['element', 'href', 'parentEventId', 'parent_event_id'])
      const destination = params.href

      if (destination) {
        return track('Link Clicked', {
          ...rest,
          entity_name: params.element,
          destination_url: destination,
          link_copy: params.element,
          parent_event_id: params.parentEventId,
          element: params.element,
          href: destination,
        })
      }

      return track('Element Interacted', {
        ...rest,
        entity_name: params.element,
        parent_event_id: params.parentEventId,
        element: params.element,
      })
    },
    [track]
  )
}
